import { useTranslation } from 'react-i18next'

import { article as articleUi } from '@/shared/lib/articleStyles'

export function ArticleAiDisclosure() {
    const { t } = useTranslation()

    return (
        <aside
            className={articleUi.aiDisclosure}
            aria-label={t('article.aiDisclosure.ariaLabel', 'Writing and image disclosure')}
        >
            <p className={articleUi.aiDisclosureText}>
                {t(
                    'article.aiDisclosure.text',
                    'This article was written with writing support from AI trained by the Tipi team.',
                )}
            </p>
            <p className={articleUi.aiDisclosureText}>
                {t('article.aiDisclosure.images', 'The images may also have been created with AI.')}
            </p>
        </aside>
    )
}
